<template>

    <div class="page-content">
        <div class="container-fluid">

            <div class="row">

                <!-- <p class="alert alert-success text-center"
                    style="width: 100%" 
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                    {{ $t('app.welcome') }}
                </p> -->

                <TotalCard
                    :table="'companies'"
                    :title="$t('chart.total_companies')"
                    :icon="'bx bx-buildings'">
                </TotalCard>
                <!-- <TotalCard
                    :table="'contract_types'"
                    :title="$t('chart.total_contract_types')"
                    :icon="'bx bx-layout'">
                </TotalCard> -->
                <TotalCard
                    :table="'contracts'"
                    :title="$t('chart.total_contracts')"
                    :icon="'bx bx-folder-open'">
                </TotalCard>
                <TotalCard
                    :table="'bills'"
                    :title="$t('chart.total_bills')"
                    :icon="'bx bx-wallet-alt'">
                </TotalCard>


                <TotalCard
                    :table="'bond_types'"
                    :title="$t('chart.total_bond_types')"
                    :icon="'bx bx-copy-alt'">
                </TotalCard>
                <!-- <TotalCard
                    :table="'financial_bonds'"
                    :title="$t('chart.total_financial_bonds')"
                    :icon="'bx bx-receipt'">
                </TotalCard>
                <TotalCard
                    :table="'auto_equipment'"
                    :title="$t('chart.total_auto_equipment')"
                    :icon="'bx bx-car'">
                </TotalCard>
                <TotalCard
                    :table="'licenses'"
                    :title="$t('chart.total_licenses')"
                    :icon="'bx bx-file'">
                </TotalCard>

                <TotalCard
                    :table="'company_licenses'"
                    :title="$t('chart.total_company_licenses')"
                    :icon="'bx bx-building-house'">
                </TotalCard>
                <TotalCard
                    :table="'roles'"
                    :title="$t('chart.total_roles')"
                    :icon="'bx bx-lock'">
                </TotalCard>
                <TotalCard
                    :table="'notifications'"
                    :title="$t('chart.total_notifications')"
                    :icon="'bx bx-bell'">
                </TotalCard>
                <TotalCard
                    :table="'users'"
                    :title="$t('chart.total_admins')"
                    :icon="'bx bx-user'">
                </TotalCard>

                <TotalCard
                    :table="'employees'"
                    :title="$t('chart.total_employees')"
                    :icon="'bx bx-user-pin'">
                </TotalCard> -->
                <!-- <TotalCard
                    :table="'absences'"
                    :title="$t('chart.total_absences')"
                    :icon="'bx bx-user-minus'">
                </TotalCard>
                <TotalCard
                    :table="'vacations'"
                    :title="$t('chart.total_vacations')"
                    :icon="'bx bx-bed'">
                </TotalCard>
                <TotalCard
                    :table="'rewards'"
                    :title="$t('chart.total_rewards')"
                    :icon="'bx bx-trophy'">
                </TotalCard> -->

            </div>

            <div class="row">

                <LineChart
                    :table="'contracts'">
                </LineChart>

               <!--  <PieChart
                    :table="'countries'">
                </PieChart>   -->

                <!-- <BarChart
                    :table="'companies'">
                </BarChart> -->

            </div>


        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        TotalCard: () => import('./TotalCard.vue'),
        LineChart: () => import('./LineChart.vue'),
        ////PieChart: () => import('./PieChart.vue'),
        // BarChart: () => import('./BarChart.vue')
    },
    data(){
        return {    
            //
            auth: {
                role: ''
            },
        }
    },
    mounted() {},
    watch: {
        //
    },
    created() {
        if(localStorage.getItem('role')) {
            this.auth.role = localStorage.getItem('role');
        }
    },
    methods: {
        //
    },
}
</script>
